import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedProjectId: null,
  extent: []
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setSelectProjectId: (state, { payload }) => {
        state.selectedProjectId = payload;
    },
    setExtent: (state, { payload }) => {
        state.extent = payload;
    },
  },
});

export const { setSelectProjectId, setExtent } = mapSlice.actions;
export default mapSlice.reducer;